export const getLevelContiguousUnderBuiltLinearValidity = (
  contiguousUnderBuiltLinear: number | undefined,
  maxContiguousUnderBuiltLinear: number
): boolean =>
  contiguousUnderBuiltLinear === undefined ||
  contiguousUnderBuiltLinear <= maxContiguousUnderBuiltLinear;
